import { MicrosoftAppType } from '../models/moovStepDefinition';

export class MicrosoftIsEntityAuthorizedRequest{
    public customerId!:number;
    public clientIds:number[]=[];
    public appType?:MicrosoftAppType; //missing means 'calendar'
}
